import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: '#111916', color: '#E8F5EE', border: '1px solid #1E2E24' },
          success: { iconTheme: { primary: '#00C896', secondary: '#0A0F0D' } },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
)
